module.exports = __webpack_public_path__ + "img/placeholder.6ab37003.svg";